import React from "react";
import SideBarWrapper from "../../components/common/sidebarWrapper";
import WithDrawal from "../../components/Wallet/WithDrawal/WithDrawal";

export default function WithDrawalPage() {
  return (
    <SideBarWrapper>
      <WithDrawal/>
    </SideBarWrapper>
  );
}
